import { gql } from '@apollo/client';

const GET_RECENT_TEMPLATES = gql`
  query GetRecentTaskListTemplates($first: Int) {
    viewer {
      __typename
      id
      recentlyUsedTaskListTemplates(first: $first) {
        nodes {
          id
          name
          description
          isOwner
          owner {
            ... on PublicTaskListPartner {
              id
              name
              logo
            }
            ... on PublicCompany {
              id
              name
              logo
            }
          }
        }
      }
    }
  }
`;

export default GET_RECENT_TEMPLATES;
